import topic from '../topic'
export const macpAPI = {
    getMacps: topic.macpTopic + '/get_macps',
    getNotDoneMacp: topic.macpTopic + '/get_not_done_macp',
    countNotDoneMacp: topic.macpTopic + '/count_not_done_macp',
    getAbnormalMacp: topic.macpTopic + '/get_abnormal_macp',
    countAbnormalMacp: topic.macpTopic + '/count_abnormal_macp',
    updateScanById: topic.macpTopic + '/update_scan_by_id',
    editMacpRemark: topic.macpTopic + '/edit_macp_remark',
}